const AppointmentTypeStrings = {
    IN_SHOP: "Inshop",
    MOBILE: "Mobile",
    DROP_OFF: "Dropoff",
};

const PREMIUM_TIME_SLOT_ID_FLAG = "-PREMIUM";

const PREMIUM_FEE_PART_TYPE = "EARLY BIRD";

const PRICING_BY_DAY_PART_TYPE = "PREMAPPT GEN";

const RouteCodeFlags = {
    ALL_DAY_DROP_OFF: "ALL DAY DROP OFF",
    OVERNIGHT_DROP_OFF: "OVERNIGHT DROP OFF",
};

export {
    AppointmentTypeStrings,
    PREMIUM_TIME_SLOT_ID_FLAG,
    PREMIUM_FEE_PART_TYPE,
    PRICING_BY_DAY_PART_TYPE,
    RouteCodeFlags,
};
